import { type ConditionalFormattingColorValue } from "./ConditionalFormattingCategoryColor";
import CategoryColor from "owa-categories/lib/store/schema/CategoryColor";

export const darkColorCodeValueMap: {
    [color: string]: ConditionalFormattingColorValue;
} = {
    [CategoryColor.None]: {
        restColor: "transparent",
        primaryColor: "#666666",
        buttonColor: "#666666",
        iconColor: "#ffffff",
        textColor: "#d6d6d6",
        hoverColor: "#383838",
        activeColor: "transparent",
        disabledColor: "#4d4d4d",
        disabledTextColor: "#7a7a7a",
        disabledIconColor: "#7a7a7a",
    },
    
    [CategoryColor.DarkRed]: {
        restColor: "#35171C",
        primaryColor: "#AC4F5E",
        buttonColor: "#AC4F5E",
        iconColor: "#D69CA5",
        textColor: "#E9C7CD",
        hoverColor: "#420610",
        activeColor: "#590815",
        textSelectedHoverColor: "#F9F0F2",
    },
    
    [CategoryColor.Cranberry]: {
        restColor: "#4B181C",
        primaryColor: "#DC626D",
        buttonColor: "#DC626D",
        iconColor: "#DC626D",
        textColor: "#F6D1D5",
        hoverColor: "#6E0811",
        activeColor: "#960B18",
        textSelectedHoverColor: "#FDF2F4",
    },
    
    [CategoryColor.DarkOrange]: {
        restColor: "#7A2101",
        primaryColor: "#F4BFAB",
        buttonColor: "#F4BFAB",
        iconColor: "#E36537",
        textColor: "#F9DCD1",
        hoverColor: "#A62D01",
        activeColor: "#DA3B01",
    },
    
    [CategoryColor.Bronze]: {
        restColor: "#5E2405",
        primaryColor: "#E5BBA4",
        buttonColor: "#E5BBA4",
        iconColor: "#CA8057",
        textColor: "#F1D9CC",
        hoverColor: "#963A08",
        activeColor: "#A74109",
    },
    
    [CategoryColor.Peach]: {
        restColor: "#281F14",
        primaryColor: "#FFBA66",
        buttonColor: "#FFBA66",
        iconColor: "#FF8C00",
        textColor: "#FFDDB3",
        hoverColor: "#291600",
        activeColor: "#4D2A00",
        textSelectedHoverColor: "#FFEDD6",
    },
    
    [CategoryColor.Marigold]: {
        restColor: "#272114",
        primaryColor: "#F2C661",
        buttonColor: "#F2C661",
        iconColor: "#EAA300",
        textColor: "#FCEFD3",
        hoverColor: "#261A00",
        activeColor: "#463100",
        textSelectedHoverColor: "#FEFBF4",
    },
    
    [CategoryColor.Gold]: {
        restColor: "#3A2F00",
        primaryColor: "#DAC157",
        buttonColor: "#DAC157",
        iconColor: "#C19C00",
        textColor: "#F5EECE",
        hoverColor: "#6D5700",
        activeColor: "#C19C00",
    },
    
    [CategoryColor.DarkBrown]: {
        restColor: "#2B1710",
        primaryColor: "#946B5C",
        buttonColor: "#946B5C",
        iconColor: "#CAADA3",
        textColor: "#E3D2CB",
        hoverColor: "#623A2B",
        activeColor: "#4D291C",
    },
    
    [CategoryColor.Lime]: {
        restColor: "#252D19",
        primaryColor: "#A4CC6C",
        buttonColor: "#A4CC6C",
        iconColor: "#A4CC6C",
        textColor: "#E5F1D3",
        hoverColor: "#23330B",
        activeColor: "#405F14",
        textSelectedHoverColor: "#F8FCF4",
    },
    
    [CategoryColor.Forest]: {
        restColor: "#162702",
        primaryColor: "#85B44C",
        buttonColor: "#85B44C",
        iconColor: "#6BA02B",
        textColor: "#BDD99B",
        hoverColor: "#376304",
        activeColor: "#498205",
    },
    
    [CategoryColor.LightGreen]: {
        restColor: "#063004",
        primaryColor: "#5EC75A",
        buttonColor: "#5EC75A",
        iconColor: "#5EC75A",
        textColor: "#CEF0CD",
        hoverColor: "#0B5A08",
        activeColor: "#13A10E",
    },
    
    [CategoryColor.DarkGreen]: {
        restColor: "#152415",
        primaryColor: "#4DA64D",
        buttonColor: "#4DA64D",
        iconColor: "#4DA64D",
        textColor: "#C6E7C6",
        hoverColor: "#032003",
        activeColor: "#063B06",
        textSelectedHoverColor: "#9AD29A",
    },
    
    [CategoryColor.LightTeal]: {
        restColor: "#142F31",
        primaryColor: "#58D3DB",
        buttonColor: "#58D3DB",
        iconColor: "#58D3DB",
        textColor: "#A6E9ED",
        hoverColor: "#00373A",
        activeColor: "#00666D",
        textSelectedHoverColor: "#C3E1E8",
    },
    
    [CategoryColor.DarkTeal]: {
        restColor: "#003939",
        primaryColor: "#218B8B",
        buttonColor: "#218B8B",
        iconColor: "#41A3A3",
        textColor: "#92D1D1",
        hoverColor: "#005C5C",
        activeColor: "#006666",
    },
    
    [CategoryColor.Steel]: {
        restColor: "#141B1D",
        primaryColor: "#4496A9",
        buttonColor: "#4496A9",
        iconColor: "#94C8D4",
        textColor: "#94C8D4",
        hoverColor: "#000F12",
        activeColor: "#001B22",
        textSelectedHoverColor: "#C3E1E8",
    },
    
    [CategoryColor.SkyBlue]: {
        restColor: "#143740",
        primaryColor: "#63D7F7",
        buttonColor: "#63D7F7",
        iconColor: "#63D7F7",
        textColor: "#D4F4FD",
        hoverColor: "#004659",
        activeColor: "#006A88",
        textSelectedHoverColor: "#F4FCFE",
    },
    
    [CategoryColor.DarkBlue]: {
        restColor: "#002039",
        primaryColor: "#4178A3",
        buttonColor: "#4178A3",
        iconColor: "#92B5D1",
        textColor: "#C2D6E7",
        hoverColor: "#002039",
        activeColor: "#002B4E",
        textSelectedHoverColor: "#EFF4F9",
    },
    
    [CategoryColor.Lavender]: {
        restColor: "#252237",
        primaryColor: "#A79CF1",
        buttonColor: "#A79CF1",
        iconColor: "#A79CF1",
        textColor: "#E7E4FB",
        hoverColor: "#221D46",
        activeColor: "#3F3682",
        textSelectedHoverColor: "#F9F8FE",
    },
    
    [CategoryColor.DarkPurple]: {
        restColor: "#240F3C",
        primaryColor: "#633E8F",
        buttonColor: "#633E8F",
        iconColor: "#B9A3D3",
        textColor: "#B9A3D3",
        hoverColor: "#512B7E",
        activeColor: "#401B6C",
    },
    
    [CategoryColor.Pink]: {
        restColor: "#361D2D",
        primaryColor: "#EF85C8",
        buttonColor: "#EF85C8",
        iconColor: "#EA66BA",
        textColor: "#FBDDF0",
        hoverColor: "#441232",
        activeColor: "#80215D",
        textSelectedHoverColor: "#FEF6FB",
    },
    
    [CategoryColor.Plum]: {
        restColor: "#351429",
        primaryColor: "#AD4589",
        buttonColor: "#AD4589",
        iconColor: "#D696C0",
        textColor: "#E9C4DC",
        hoverColor: "#43002B",
        activeColor: "#5A003B",
        textSelectedHoverColor: "#FAF0F6",
    },
    
    [CategoryColor.Beige]: {
        restColor: "#444241",
        primaryColor: "#AFABAA",
        buttonColor: "#AFABAA",
        iconColor: "#AFABAA",
        textColor: "#EAE8E8",
        hoverColor: "#5D5958",
        activeColor: "#7A7574",
    },
    
    [CategoryColor.Mink]: {
        restColor: "#343231",
        primaryColor: "#84817E",
        buttonColor: "#84817E",
        iconColor: "#9E9B99",
        textColor: "#CECCCB",
        hoverColor: "#54514F",
        activeColor: "#5D5A58",
    },
    
    [CategoryColor.Silver]: {
        restColor: "#282A2B",
        primaryColor: "#B3BFC2",
        buttonColor: "#B3BFC2",
        iconColor: "#A0AEB1",
        textColor: "#D8DFE0",
        hoverColor: "#282D2E",
        activeColor: "#4A5356",
        textSelectedHoverColor: "#EAEEEF",
    },
    
    [CategoryColor.Charcoal]: {
        restColor: "#181818",
        primaryColor: "#888888",
        buttonColor: "#888888",
        iconColor: "#888888",
        textColor: "#C4C4C4",
        hoverColor: "#090909",
        activeColor: "#111111",
        textSelectedHoverColor: "#DFDFDF",
    },
    
    [CategoryColor.BlackWhite]: {
        restColor: "transparent",
        primaryColor: "#FFFFFF",
        buttonColor: "#FFFFFF",
        iconColor: "#FFFFFF",
        textColor: "#FFFFFF",
        hoverColor: "transparent",
        activeColor: "transparent",
        textSelectedHoverColor: "#FFFFFF",
    },
};
